
import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {PlatformQuery} from "@shared/models/platform-query/platform-query";
import {CommandService} from "@core/services/command.service";
import {EliteFormFlowChartDataService} from "@features/elite-form/services/elite-form-flow-chart-data.service";
import {EliteFormDesignService} from "@features/elite-form/services/elite-form-design.service";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {takeUntil, debounceTime, filter, map, distinctUntilChanged, switchMap } from "rxjs/operators";
import {Subject} from 'rxjs';
import {EliteformTableOfContentsService} from "@shared/components/platform-tool/platform-tool-dialog-definition/services/eliteform-table-of-contents.service";
import {IPlatformHomeMagicBar} from "@shared/components/platform-tool/platform-tool-magic-bar/models/magic-bar-models";
import {HomeSideBarItem} from "@shared/models/platform-tool-models";
import {Api} from "@shared/constants/common-field.constants";
import {FormResponseViewService} from "@features/elite-form/services/form-response-view.service";

export interface EliteFormResponsePayload {
  id: string;
  title: string;
  responseTitle: string;
  relativePath: string;
  pdfTemplateRelativePath: string;
  pages: EliteFormPageResponse[];
}
export interface EliteFormPageResponse {
  title: string;
  originalPageNumber: number;
  questions: EliteFormQuestionResponse[];
  metadata: { [key: string]: any };
}
export interface EliteFormQuestionResponse {
  title: string;
  description: string;
  row: number;
  column: number;
  columnSpan: number;
  rowSpan: number;
  type: string;
  dataType: string;
  value: string;
  isMultiResponse: boolean;
  liquidTemplateFieldKey: string;
  mappedFieldKey: string;
  fieldKey: string;
  pdfFieldKey: string;
  expressionId: string;
  formula: string;
  dataItemId: string;
  errorInfo: ErrorInfoModel;
  skipCurrencyConversion: boolean;
  questions: EliteFormQuestionResponse[];
}
export interface ErrorInfoModel {
  totalMandatoryFields: number;
  totalEmptyFields: number;
  totalEmptyMandatoryFields: number;
  totalErrorCount: number;
  errorMessages: string[];
}


@Component({
    standalone: false,
    selector: 'app-elite-form-table-of-contents-container',
  templateUrl: './elite-form-table-of-contents-container.component.html',
  styleUrl: './elite-form-table-of-contents-container.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class EliteFormTableOfContentsContainerComponent implements IPlatformHomeMagicBar, OnInit, OnDestroy{
  homeSideBarItem: HomeSideBarItem;

  ngUnsubscribe$ = new Subject<void>();
  eliteFormId:string;
  schemaId:string;
  flowchartId:string;
  responseId:string;
  isClientSchema:boolean;
  responsePayload: EliteFormResponsePayload;
  pages: EliteFormPageResponse[];
  currentPage:number = 0;
  errorCountToolTip:string = "Validation warnings";
  initialized = false;
  trackByPage = (_: number, page: EliteFormPageResponse) =>
    page.originalPageNumber ?? page.title;

  constructor(
    private commandService: CommandService,
    private eliteFormDesignService: EliteFormDesignService,
    private platformQueryService: PlatformQueryService,
    private eliteFormFlowChartDataService: EliteFormFlowChartDataService,
    private tocService: EliteformTableOfContentsService,
    private formResponseViewService: FormResponseViewService
  ) {}

  ngOnInit(): void {
    this.schemaId = this.homeSideBarItem.fieldValues["SchemaId"];
    this.responseId = this.homeSideBarItem.fieldValues["ResponseId"];
    this.isClientSchema = this.homeSideBarItem.fieldValues["IsClientSchema"];

    /*this.getFormResponseErrorInfo()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(response =>{
        this.responsePayload = response.fieldValues['Payload'];
        this.pages = this.responsePayload.pages;

        this.tocService.currentPage$
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe(index => {
            this.currentPage = index ?? 0;
          });
      });*/

    this.formResponseViewService.refreshTableOfContents$
      .pipe(
        debounceTime(250),
        switchMap(() => this.getFormResponseErrorInfo()),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(response => {
        this.responsePayload = response.fieldValues['Payload'];
        this.pages = this.responsePayload.pages;
        if(!this.initialized){
          this.tocService.currentPage$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(index => {
              this.currentPage = index ?? 0;
            });
          this.initialized = true;
        } else {
          const prevPage = this.currentPage ?? 0;
          this.tocService.setCurrentPage(prevPage);
        }
      });
  }

  getFormResponseErrorInfo(){
    const query = new PlatformQuery();
    query.name = 'FormResponseErrorQuery';
    query.api = Api.FilingManagerApi;
    query.fieldValues['ResponseId'] = this.responseId;
    query.fieldValues['IsClientSchema'] = this.isClientSchema;
    query.fieldValues['SchemaId'] = this.schemaId;
    return this.platformQueryService.executeQuery(query);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  getErrorCount(page: EliteFormPageResponse) {
    const questions = page.questions;
    let errorCount = 0;
    for(const question of questions){
      if(question==null) continue;
      errorCount+=question.errorInfo.totalErrorCount;
    }
    return errorCount;
  }

  // scrollToPage(pageIndex: number) {
  //   this.tocService.goToPage((pageIndex));
  //   this.currentPage = pageIndex;
  // }

  onPanelOpened(index: any) {
    if (this.currentPage !== index) {
      this.currentPage = index;
      this.tocService.goToPage(index);
    }
  }
}
